import { AUTH_URL, AUTH_API_TOKEN, authToken } from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'
const authAxiosInstaceV1 = axios.create({
  baseURL: `${AUTH_URL}/api/v1`,
  headers: {
    'api-token': AUTH_API_TOKEN
  }
})
authAxiosInstaceV1.interceptors.response.use(function (response) {
  if (response.data.redirect_to) {
    location.href = response.data.redirect_to
  }
  return response
}, function (error) {
  if (error.response.status === 401 || error.response.status === 403) {
    EventBus.$emit('unauthorized')
  }
  if (error.response.status !== 404) {
    EventBus.$emit('show-error-modal', error)
  }
  return Promise.reject(error)
})
export const AuthAPI = {

  /**
   * Login user with Email and Password
   * @param {string} [data={ email: '', password: '' }]
   * @returns {Promise}
   */
  login(data = { email: '', password: '' }) {
    return authAxiosInstaceV1({
      url: `/auth/login/local`,
      method: 'POST',
      data: data
    })
  },
  /**
   *
   * Login user with userToken
   * @param {*} token
   * @returns
   */
  loginWithToken(token) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/users/profile`,
      headers: {
        'auth-token': token,
        'api-token': AUTH_API_TOKEN
      }
    })
  },

  /**
   * Call to get list of user locations
   *
   * @returns {Promise}
   */
  getUserLocations() {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/locations/',
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },

  /**
   * Call to get list of user businesses
   *
   * @returns {Promise}
   */
  getUserBusinesses() {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/users/businesses',
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },

  /**
   * Call to get list of user businesses when not logged in
   *
   * @returns {Promise}
   */
  getUserBusinessesNotLoggedIn(token) {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/users/businesses',
      headers: {
        'auth-token': token,
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  /**
   * Call to set users active business
   *
   * @param {*} businessId
   * @returns {Promise}
   */
  setActiveBusiness(businessId) {
    return authAxiosInstaceV1({
      method: 'patch',
      url: `/users/businesses/${businessId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  /**
   *  Call to get a business by id
   *
   * @returns {Promise}
   */
  getBusinessById(businessId, withBranding = false) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/businesses/${businessId}?withBranding=${withBranding}`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  },
  logout() {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/users/logout`,
      headers: {
        'auth-token': authToken(),
        'api-token': AUTH_API_TOKEN
      }
    })
  }
}
